// Data pro Gastrofestival Cesta Kolem Světa

export const festivalInfo = {
  name: "GASTROFESTIVAL \"CESTA KOLEM SVĚTA\"",
  subtitle: "4. ROČNÍK",
  date: "16.–17. května 2026",
  location: "Masarykovo náměstí, 686 01 Uherské Hradiště",
  expectedVisitors: "10 000",
  entrance: "VSTUPNÉ ZDARMA",
  eventId: "cesta-kolem-sveta-2026",
};

export const programSchedule = {
  saturday: {
    day: "Sobota 16. 5. 2026",
    time: "11:00–20:00",
    description: "Celosvětové kulinářské speciality",
  },
  sunday: {
    day: "Neděle 17. 5. 2026",
    time: "11:00–17:00",
    description: "Rodinný den s bohatým programem",
  },
};

export const programHighlights = [
  "Bohatý program pro děti",
  "Živá hudba a kapely",
  "Soutěže v pojídání",
  "Kuchařské show",
  "Škola vaření pro děti",
  "Barevné sushi Lukáš Neckář",
  "Železný zekon",
  "Zpěvák Honza Grebík",
  "Kouzelné hrátky s Jiřím Hadašem"
];

export const whyJoinReasons = [
  {
    title: "Vysoká návštěvnost",
    description: "Gastrofestival navštíví cca 10 000 osob během dvou dnů. Masarykovo náměstí je centrem města s výbornou dostupností.",
    icon: "Users",
  },
  {
    title: "Rodinná atmosféra",
    description: "Festival zaměřený na rodiny s dětmi a milovníky dobrého jídla. Návštěvníci zůstávají v prostoru celé odpoledne.",
    icon: "Heart",
  },
  {
    title: "Multikulturní téma",
    description: "Cesta kolem světa - americké burgery, mexické quesadillas, italské pizzatiny, vietnamské polévky, japonské sushi a mnoho dalšího.",
    icon: "Globe",
  },
  {
    title: "Osvědčený koncept",
    description: "Již 4. ročník úspěšného gastrofestivalu v centru Uherského Hradiště.",
    icon: "CheckCircle2",
  },
  {
    title: "Dlouhé otevírací hodiny",
    description: "Sobota 11:00-20:00 (9 hodin), Neděle 11:00-17:00 (6 hodin) = celkem 15 hodin prodejního času.",
    icon: "Clock",
  },
  {
    title: "Centrum města",
    description: "Masarykovo náměstí v centru Uherského Hradiště přitahuje jak místní obyvatele, tak návštěvníky z širokého okolí.",
    icon: "MapPin",
  },
];

export const vendorCategories = {
  priority: {
    title: "PRIORITA: Food Trucky a stánky s jídlem",
    description: "Hledáme pestrou nabídku kuchyní ze světa - americké, mexické, italské, asijské, tradiční českou i další speciality.",
    requirements: [
      "Zkušenosti z festivalů a venkovních akcí",
      "Kapacitní obsluha",
      "Rychlé odbavení zákazníků",
      "Multikulturní koncepty vítány",
    ],
  },
  additional: {
    title: "Doplňkový prodej",
    description: "Omezený počet míst pro doplňkový sortiment",
    categories: [
      "Zajímavé stánky se sladkým sortimentem (cheesecake, cup cakes, pavlova)",
      "Rolovaná zmrzlina",
      "Exotické ovoce, ovoce v kelímku",
      "Koření a omáčky k masu",
      "Gastro zařízení (grily, nože, prkýnka apod.)",
    ],
  },
};

export const importantRules = [
  {
    title: "Zákaz prodeje nápojů",
    description: "Alkoholické i nealkoholické nápoje (teplé i studené) zajišťuje výhradně pořadatel.",
    note: "Výjimky pouze po předchozí domluvě s pořadatelem.",
    icon: "XCircle",
  },
  {
    title: "Ceny bez DPH",
    description: "Všechny uvedené ceny jsou bez DPH. DPH bude připočítáno podle platné legislativy.",
    icon: "CreditCard",
  },
];

export const pricingConditions = {
  foodTrucks: {
    title: "FOOD TRUCKY/STÁNKY s jídlem",
    size: "do 6x3m",
    category: "hlavní prodejci jídla",
    price: "9.000 Kč/den",
  },
  additional: {
    title: "SLADKÉ, POCHUTINY, VÝROBKY, HRAČKY",
    size: "max. 6x3m",
    category: "ostatní prodejci",
    price: "2.800 Kč/den",
  },
  electricity: {
    title: "ENERGIE - příkon (MAX 12 KW)",
    options: [
      { range: "DO 3KW", price: "1.750 Kč" },
      { range: "3KW až 6KW", price: "3.300 Kč" },
      { range: "nad 6KW", price: "4.500 Kč" },
    ],
    note: "(celá akce)",
  },
  note: "Ceny jsou uvedeny bez DPH",
};

export const contactInfo = {
  name: "Monika Ondruchová",
  phone: "+420 773 550 880",
  email: "monika@vseproakci.cz",
};

export const heroImage = "https://images.unsplash.com/photo-1762219926429-6eb911ac1bdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxmb29kJTIwZmVzdGl2YWwlMjBjcm93ZCUyMGZvb2QlMjB0cnVja3MlMjBvdXRkb29yJTIwZXZlbnR8ZW58MHx8fHwxNzczMDc3MzAxfDA&ixlib=rb-4.1.0&q=85";

export const flyerImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/r46v3moy_priloha_1471068402_8_Gastrofestival_1000x2000_final_-scaled.jpg";

export const videoUrl = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/rcqy8dtp_reelgastrofest.mp4";
